module.exports = __webpack_public_path__ + "static/fipcwhitesheep-0d9d310b170fe2672fe2142be7da3d04.jpeg";